






































import Vue from 'vue';
import PauseTube from './PauseTube.vue';
import { reactive, onMounted } from '@vue/composition-api';
import { eventBus } from '../main';

export default Vue.extend({
  components: { PauseTube },
  props: {
    client: { type: String, default: '' },
    dataSource: { type: String, default: '' },
    enabled: { type: Boolean, default: false },
    icon: { type: String, default: 'replay' },
    iconColor: { type: String, default: 'black' },
  },
  setup(props) {
    const state = reactive({ dialog: false });

    onMounted(() => eventBus.$on('schedule', () => (state.dialog = false)));

    return { state };
  },
});
